 /**
  * File: submissionList.js
  * Project: educore
  * Created Date: 2019-01-23
  * Author: Raziya S
  * Screen : 
  */
 class SubmissionController {
     // @ngInject
     constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS) {

         this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
         let authoring = localStorageService.get("authoringData")
         if (authoring === undefined)
             $state.go('dashboard')
         $scope.score = 0
         let qpId = $state.params.qpId
         let activityId
         $scope.minutes = []
         for (var min = 5; min <= 20; min += 5) {
             $scope.minutes.push(min);
         }
         $scope.isLoading = true
         $scope.class = authoring.class
         let userId = localStorageService.get('user_id')
         let schoolId = authoring.school_id
         authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
             if (response.result && response.result.status && response.result.data.details) {
                 let result = response.result.data.details
                 console.log(result)
                 $scope.qpHeader = {
                     'schoolName': result.school_name,
                     'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                     'subject': authoring.subject,
                     'class': authoring.class
                 }
                 $scope.$apply()
             } else {
                 //error
             }
         })

         authService.callAPI(activityCons.API_GET_QP_DETAILS + qpId, "GET", {}, function(response) {
             console.log(response)
             if (response.result && response.result.data && response.result.data.details) {
                 try {
                    $scope.isLoading = false
                     $scope.questionPaper = response.result.data.details;
                     console.log("***************")
                     console.log($scope.questionPaper)
                     activityId = $scope.questionPaper.activity_id
                     if ($scope.questionPaper && $scope.questionPaper.time) {
                         $scope.hour = $scope.questionPaper.time.hour;
                         $scope.min = $scope.questionPaper.time.min;
                     }
                     if ($scope.questionPaper && $scope.questionPaper.due_date) {
                         $scope.date = $scope.questionPaper.due_date;
                     }
                     if ($scope.questionPaper && $scope.questionPaper.students) {
                         $scope.assignedUsers = $scope.questionPaper.students;
                     }
                 } catch (ex) {
                     console.log(ex);
                 }
             } else {
                 toastr.error('Network Error. Please try later');
             }
             _.defer(function() {
                 $scope.$apply();
             });
         });
         $scope.answerPreview = function(studentId) {
             $state.go('teacherAnswerPreview', {
                 qpId: qpId,
                 studentId: studentId
             })
         }

         $scope.checkingChoiceExists = function(choice, data) {
             let isChecked = false;
             if (data.my_answer != undefined) {
                 return data.my_answer.indexOf(choice) > -1
             } else {
                 return isChecked
             }
         }

         let MQ = MathQuill.getInterface(2);
         $scope.loadLatex = function() {
             let questionElements = document.getElementsByClassName('question_desc')
             _.each(questionElements, function(spanElement) {
                 MQ.StaticMath(spanElement);
             })
         }

         $scope.markValidation = (questionId, sectionIndex, section, qnMark) => {
             let answersMarkCount = 0
             _.each(section.answers, function(data) {
                 if (parseFloat(data.my_score) > 0) {
                     answersMarkCount++
                 }
             })
             if (answersMarkCount > section.mandatory_no) {
                 let questionIndex = section.answers.findIndex(i => i._id === questionId)
                 section.answers[questionIndex].my_score = 0
                 toastr.error(" You have already entered the marks all mandatory question")
                 section.answers[sectionIndex]
             };
             let actualScore = 0;
             let totalScore = qnMark
             let questionIndex = $scope.questions[sectionIndex].answers.findIndex(i => i._id === questionId)
             if (questionIndex > -1) {
                 actualScore = $scope.questions[sectionIndex].answers[questionIndex].my_score
             }
             if (actualScore > totalScore)
                 $scope.questions[sectionIndex].answers[questionIndex].my_score = 0
         }

         function removeSpecialCharacter(value) {
             if (value) {
                 value = value.toString().replace(/\\quad/g, "")
                 value = value.toString().replace(/\\/g, "")
             }
             return value
         }

         /* Set answered choice is wrong or correct*/
         function setChoice() {
             _.each($scope.questions, function(section) {
                 _.each(section.answers, function(data, key) {
                     $scope.total_mark += parseFloat(data.mark)
                     let score = parseFloat(data.my_score)
                     $scope.score += score;
                     if (data.type == 'MCQ' || data.type == "IBT_MCQ") {
                         _.each(data.choice, function(choice) {
                             if ($scope.checkingChoiceExists(choice.desc, data)) {
                                 if (!choice.correct) {
                                     choice.wrong = true
                                 }
                             }
                         })
                     } else if (data.type == 'TF') {
                         _.each(data.choice, function(choice) {
                             if (data.my_answer != undefined && choice.tag === data.my_answer[0]) {
                                 if (!choice.correct) {
                                     choice.wrong = true
                                 } else {
                                     choice.correct = true
                                 }
                             }
                         })
                     } else if (data.type == 'FIB' || data.type == "IBT_FIB") {
                         let key = 0
                         _.each(data.answer, function(choice) {
                             let correctAnswer = removeSpecialCharacter(choice.desc)
                             if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                 let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                 if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                     choice.wrong = true
                                 } else {
                                     choice.correct = true
                                 }
                             } else {
                                 choice.wrong = true
                                 if (data.my_answer != undefined) {
                                     data.my_answer[key] = 'Not Answered'
                                 } else {
                                     data.my_answer = []
                                     data.my_answer[key] = 'Not Answered'
                                 }
                             }
                             key++
                         })
                     } else if (data.type == 'OWQ') {
                         let key = 0
                         _.each(data.answer, function(choice) {
                             let correctAnswer = removeSpecialCharacter(choice.desc)
                             if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                 let studentAnswer = removeSpecialCharacter(data.my_answer[key])
                                 if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                     choice.wrong = true
                                 } else {
                                     choice.correct = true
                                 }
                             } else {
                                 choice.wrong = true
                                 if (data.my_answer != undefined) {
                                     data.my_answer[key] = 'Not Answered'
                                 } else {
                                     data.my_answer = []
                                     data.my_answer[key] = 'Not Answered'
                                 }
                             }
                             key++
                         })
                     } else if (data.type == 'MTF') {
                         data.ans_key = []
                         let key = 0
                         _.each(data.option, function(choice) {
                             let correctAnswer = removeSpecialCharacter(choice.answer.desc)
                             if (data.my_answer != undefined && data.my_answer[key] != undefined) {
                                 let correct = false
                                 let studentAnswer = removeSpecialCharacter(data.my_answer[key].desc)
                                 if (correctAnswer !== studentAnswer) {
                                     correct = false
                                 } else {
                                     correct = true
                                 }
                                 data.ans_key.push({
                                     desc: data.my_answer[key].desc,
                                     correct: correct,
                                     optImage: data.my_answer[key].optImage
                                 })
                             }
                             key++
                         })
                     } else if (data.type == 'ASLLISTEN') {
                         _.each(data.questions, function(aslListQues) {
                             if (aslListQues.type == 'mcq') {
                                 _.each(aslListQues.choice, function(choice) {
                                     if ($scope.checkingChoiceExists(choice.desc, aslListQues)) {
                                         if (!choice.correct) {
                                             choice.wrong = true
                                         }
                                     }
                                 })
                             } else if (aslListQues.type == 'tf') {
                                 _.each(aslListQues.choice, function(choice) {
                                     if (aslListQues.my_answer != undefined && choice.tag === aslListQues.my_answer) {
                                         if (!choice.correct) {
                                             choice.wrong = true
                                         } else {
                                             choice.correct = true
                                         }
                                     }
                                 })
                             } else if (aslListQues.type == 'fib') {
                                 _.each(aslListQues.answer, function(choice, index) {
                                     let correctAnswer = removeSpecialCharacter(choice.desc)
                                     if (aslListQues.my_answer != undefined && aslListQues.my_answer[index] != undefined) {
                                         let studentAnswer = removeSpecialCharacter(aslListQues.my_answer[index])
                                         if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                             choice.wrong = true
                                         } else {
                                             choice.correct = true
                                         }
                                     } else {
                                         choice.wrong = true
                                         if (aslListQues.my_answer != undefined) {
                                             aslListQues.my_answer[index] = 'Not Answered'
                                         } else {
                                             aslListQues.my_answer = []
                                             aslListQues.my_answer[index] = 'Not Answered'
                                         }
                                     }
                                 })
                             } else if (aslListQues.type == 'text') {
                                 let correctAnswer = removeSpecialCharacter(aslListQues.answer)
                                 if (aslListQues.my_answer != undefined) {
                                     let studentAnswer = removeSpecialCharacter(aslListQues.my_answer)
                                     if (correctAnswer.toLowerCase().trim() !== studentAnswer.toLowerCase().trim()) {
                                         aslListQues.wrong = true
                                     } else {
                                         aslListQues.correct = true
                                     }
                                 } else {
                                     aslListQues.wrong = true
                                     aslListQues.my_answer = 'Not Answered'
                                 }
                             }
                         })
                     }
                 })
             })
         }

         $scope.score = $scope.score.toFixed(2)
         $scope.cancel = function() {
             $mdDialog.hide();
         };

         $scope.gotoActivityPreview = function() {
             $state.go('activityFormPreview', {
                 resourceId: activityId
             })
         }

         $scope.saveMark = function() {
             let errorCount = 0;
             _.each($scope.questions, function(section) {
                 _.each(section.answers, function(quest) {
                     //mark_each_qn changed to qn_mark
                     //For individual mark  for each question
                     //Developer-Raziya
                     quest.qn_mark = parseFloat(quest.qn_mark)
                     if (quest.my_score > quest.qn_mark) {
                         quest.mark_error = "Enter the mark less than total mark"
                         errorCount++;
                     }
                 })
             })
             if (errorCount > 0) {
                 toastr.error("Check the marks")
             } else {
                 let requestObj = {
                     questions: $scope.questions,
                     student_id: $scope.studentId,
                     question_paper_id: $scope.questionPaper._id,
                     user_id: userId,
                     authoring_data: authoring
                 }
                 authService.callAPI(activityCons.API_UPDATE_EXAM_SCORE, "POST", requestObj, function(response) {
                     console.log(response)
                     if (response.result && response.result.data && response.result.data.message) {
                         try {
                             let result = response.result.data.message;
                             toastr.success(result);
                             $mdDialog.hide();
                         } catch (ex) {
                             console.log(ex);
                         }
                     } else {
                         toastr.error('Network Error. Please try later');
                     }
                     _.defer(function() {
                         $scope.$apply();
                     });
                 });
             }
         }

         $scope.setFilePath = function(img) {
             let new_url = img ? FILE_UPLOAD_URL + img : undefined
             return new_url
         }

         $scope.beautifyFIB = function(question) {
             return question.toString().replace(/_/g, " _______ ")
         }

         function getTime(millseconds) {
             var oneSecond = 1000;
             var oneMinute = oneSecond * 60;
             var oneHour = oneMinute * 60;
             var oneDay = oneHour * 24;
             var seconds = Math.floor((millseconds % oneMinute) / oneSecond);
             var minutes = Math.floor((millseconds % oneHour) / oneMinute);
             var hours = Math.floor((millseconds % oneDay) / oneHour);
             var days = Math.floor(millseconds / oneDay);
             var timeString = '';
             if (days !== 0) {
                 timeString += (days !== 1) ? (days + ' days ') : (days + ' day ');
             }
             if (hours !== 0) {
                 timeString += (hours !== 1) ? (hours + ' hours ') : (hours + ' hour ');
             }
             if (minutes !== 0) {
                 timeString += (minutes !== 1) ? (minutes + ' min ') : (minutes + ' min ');
             }
             if (seconds !== 0 || millseconds < 1000) {
                 timeString += (seconds !== 1) ? (seconds + ' sec ') : (seconds + ' sec ');
             }
             return timeString;
         }

         $scope.isString = function(value) {
             return typeof value == 'string'
         }
     }
 }
 export default SubmissionController



// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/activity/submissionList.js